import React, { PureComponent } from 'react';

interface Props {
    size?: number;
}

class FloppyDisk extends PureComponent<Props> {

    render() {
        const { size } = this.props;
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M20.5603 6.75001L17.25 3.43969C17.1112 3.2998 16.946 3.18889 16.764 3.11341C16.582 3.03792 16.3867 2.99938 16.1897 3.00001H4.5C4.10218 3.00001 3.72064 3.15804 3.43934 3.43935C3.15804 3.72065 3 4.10218 3 4.50001V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V7.81032C21.0006 7.61326 20.9621 7.41805 20.8866 7.23602C20.8111 7.054 20.7002 6.88879 20.5603 6.75001ZM15.75 19.5H8.25V14.25H15.75V19.5ZM19.5 19.5H17.25V14.25C17.25 13.8522 17.092 13.4707 16.8107 13.1893C16.5294 12.908 16.1478 12.75 15.75 12.75H8.25C7.85218 12.75 7.47064 12.908 7.18934 13.1893C6.90804 13.4707 6.75 13.8522 6.75 14.25V19.5H4.5V4.50001H16.1897L19.5 7.81032V19.5ZM15 6.75001C15 6.94892 14.921 7.13969 14.7803 7.28034C14.6397 7.42099 14.4489 7.50001 14.25 7.50001H9C8.80109 7.50001 8.61032 7.42099 8.46967 7.28034C8.32902 7.13969 8.25 6.94892 8.25 6.75001C8.25 6.5511 8.32902 6.36033 8.46967 6.21968C8.61032 6.07903 8.80109 6.00001 9 6.00001H14.25C14.4489 6.00001 14.6397 6.07903 14.7803 6.21968C14.921 6.36033 15 6.5511 15 6.75001Z" fill="currentColor"/>
</svg>
        );
    }
}

export default FloppyDisk;